import { Loader2, Lock, Maximize2, Minimize2 } from "lucide-react";
import { Button } from "@/modern/components/ui/button-shadcn";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/modern/components/ui/tooltip";
import { MANIFEST_GUIDE_TARGETS, PageGuideTrigger, guideTargetProps } from "@/react/guides";

const MANIFEST_SUBTEXT =
  "A read-only blueprint compiled from your active Context — it drives tags, hubs, SEO, and the rest of your marketing stack.";

interface ManifestDocumentHeaderProps {
  isGenerating: boolean;
  onGoToContext?: () => void;
  onShowGuide?: () => void;
  isFocused?: boolean;
  onToggleFocus?: () => void;
}

export const ManifestDocumentHeader = ({
  isGenerating,
  onGoToContext,
  onShowGuide,
  isFocused = false,
  onToggleFocus,
}: ManifestDocumentHeaderProps) => (
  <div
    {...guideTargetProps(MANIFEST_GUIDE_TARGETS.manifestHeader)}
    className="flex items-center justify-between gap-3 px-3 min-h-8 py-1.5 shrink-0 border-b border-border bg-muted/10"
  >
    <p className="text-xs text-muted-foreground leading-snug min-w-0 flex-1">{MANIFEST_SUBTEXT}</p>
    <div className="flex items-center gap-1.5 shrink-0 text-[11px] text-muted-foreground">
      {isGenerating ? (
        <span className="inline-flex items-center gap-1 mr-1">
          <Loader2 className="h-3 w-3 animate-spin" />
          Syncing…
        </span>
      ) : (
        <>
          <span className="inline-flex items-center gap-1 rounded-full border border-border bg-background px-1.5 py-0.5 font-medium">
            <Lock className="h-2.5 w-2.5" />
            Read-only
          </span>
          {onGoToContext && (
            <button
              type="button"
              onClick={onGoToContext}
              className="hidden sm:inline text-primary hover:underline font-medium mr-1"
            >
              Edit in Context
            </button>
          )}
        </>
      )}
      {onShowGuide && isFocused && <PageGuideTrigger onClick={onShowGuide} variant="inline" />}
      {onToggleFocus && (
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="h-6 w-6 text-muted-foreground hover:text-foreground"
              onClick={onToggleFocus}
              {...guideTargetProps(MANIFEST_GUIDE_TARGETS.expandManifest)}
              aria-label={isFocused ? "Exit focus mode" : "Expand manifest"}
            >
              {isFocused ? (
                <Minimize2 className="h-3.5 w-3.5" />
              ) : (
                <Maximize2 className="h-3.5 w-3.5" />
              )}
            </Button>
          </TooltipTrigger>
          <TooltipContent side="bottom" className="text-xs">
            {isFocused ? "Exit focus mode" : "Expand manifest"}
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  </div>
);
